module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-2 px-4"
  }, [(_vm.reservation.event.eventRoutes.length > 0) ? _c('div', {
    staticClass: "bg-lightest radius-normal border-light my-4 py-3 px-3 d-flex flex-column"
  }, [_c('route-form', {
    attrs: {
      "routes": _vm.getAllRoutes,
      "reservation": _vm.reservation,
      "title": "Pick up location",
      "type": 1
    }
  })], 1) : _c('div', {
    staticClass: "bg-lightest radius-normal border-light d-flex my-4 px-3"
  }, [_c('div', {
    staticClass: "text-center dark fs-largest pt-5 text-center mb-4 w-100"
  }, [_vm._v("\n            This event has no transportation available\n        ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0f47b426", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f47b426"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/AddTransport.vue
// module id = 1785
// module chunks = 0